// Theme: summer-heat
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'summer-heat',
  name: 'SUMMER HEAT',
  tagline: 'SUMMER HEAT',
  description: 'Calor de verao com contraste alto e energia quente constante.',
  category: 'organic-world',
  tier: 'epic',
  basePrice: 3675,
  swatches: ['#1A0A04', '#EF8C23', '#2A1208', '#FFF7ED'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '12px',
      '--shadow-card': '0 12px 28px rgba(0, 0, 0, 0.22)',
      '--shadow-card-active': '0 0 24px color-mix(in srgb, var(--primary) 10%, transparent)'
    },
    shellClasses: 'font-sans theme-summer-heat'
  },
  colorVars: {
    '--accent': '#EF8C23',
    '--accent-foreground': '#1A0A04',
    '--background': '#1A0A04',
    '--border': '#C05A20',
    '--card': '#2A1208',
    '--card-border-active': 'rgba(239, 140, 35, 0.48)',
    '--card-completed': '#2A1208',
    '--card-foreground': '#FFF7ED',
    '--card-glow': 'rgba(239, 140, 35, 0.1)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#EF4444',
    '--destructive-foreground': '#1A0A04',
    '--foreground': '#FFF7ED',
    '--hold-fill': '#EF8C23',
    '--input': '#2A1208',
    '--modal-bg': '#1A0A04',
    '--modal-border': '#C05A20',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 28px rgba(0, 0, 0, 0.22)',
    '--muted': '#C05A20',
    '--muted-foreground': '#FFF7ED',
    '--nav-active': '#EF8C23',
    '--nav-bg': '#1A0A04',
    '--popover': '#2A1208',
    '--popover-foreground': '#FFF7ED',
    '--primary': '#EF8C23',
    '--primary-foreground': '#1A0A04',
    '--ring': '#EF8C23',
    '--secondary': '#C05A20',
    '--secondary-foreground': '#FFF7ED',
    '--streak': '#EF8C23',
    '--success': '#22C55E',
    '--success-foreground': '#1A0A04',
    '--xp': '#EF8C23',
    '--xp-bg': '#2A1208'
  },
  resolvedVars: {
    '--accent': '#EF8C23',
    '--accent-foreground': '#1A0A04',
    '--accent-foreground-hsl': '16 73% 6%',
    '--accent-foreground-oklch': 'from #1A0A04 l c h',
    '--accent-hsl': '31 86% 54%',
    '--accent-oklch': 'from #EF8C23 l c h',
    '--background': '#1A0A04',
    '--background-hsl': '16 73% 6%',
    '--background-oklch': 'from #1A0A04 l c h',
    '--border': '#C05A20',
    '--border-hsl': '22 71% 44%',
    '--border-oklch': 'from #C05A20 l c h',
    '--border-w': '1px',
    '--card': '#2A1208',
    '--card-border-active': 'rgba(239, 140, 35, 0.48)',
    '--card-completed': '#2A1208',
    '--card-completed-hsl': '18 68% 10%',
    '--card-completed-oklch': 'from #2A1208 l c h',
    '--card-foreground': '#FFF7ED',
    '--card-foreground-hsl': '33 100% 96%',
    '--card-foreground-oklch': 'from #FFF7ED l c h',
    '--card-glow': 'rgba(239, 140, 35, 0.1)',
    '--card-hsl': '18 68% 10%',
    '--card-oklch': 'from #2A1208 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#EF4444',
    '--destructive-foreground': '#1A0A04',
    '--destructive-foreground-hsl': '16 73% 6%',
    '--destructive-foreground-oklch': 'from #1A0A04 l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #EF4444 l c h',
    '--foreground': '#FFF7ED',
    '--foreground-hsl': '33 100% 96%',
    '--foreground-oklch': 'from #FFF7ED l c h',
    '--hold-fill': '#EF8C23',
    '--hold-fill-hsl': '31 86% 54%',
    '--hold-fill-oklch': 'from #EF8C23 l c h',
    '--input': '#2A1208',
    '--input-hsl': '18 68% 10%',
    '--input-oklch': 'from #2A1208 l c h',
    '--modal-bg': '#1A0A04',
    '--modal-bg-hsl': '16 73% 6%',
    '--modal-bg-oklch': 'from #1A0A04 l c h',
    '--modal-border': '#C05A20',
    '--modal-border-hsl': '22 71% 44%',
    '--modal-border-oklch': 'from #C05A20 l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 28px rgba(0, 0, 0, 0.22)',
    '--muted': '#C05A20',
    '--muted-foreground': '#FFF7ED',
    '--muted-foreground-hsl': '33 100% 96%',
    '--muted-foreground-oklch': 'from #FFF7ED l c h',
    '--muted-hsl': '22 71% 44%',
    '--muted-oklch': 'from #C05A20 l c h',
    '--nav-active': '#EF8C23',
    '--nav-active-hsl': '31 86% 54%',
    '--nav-active-oklch': 'from #EF8C23 l c h',
    '--nav-bg': '#1A0A04',
    '--nav-bg-hsl': '16 73% 6%',
    '--nav-bg-oklch': 'from #1A0A04 l c h',
    '--popover': '#2A1208',
    '--popover-foreground': '#FFF7ED',
    '--popover-foreground-hsl': '33 100% 96%',
    '--popover-foreground-oklch': 'from #FFF7ED l c h',
    '--popover-hsl': '18 68% 10%',
    '--popover-oklch': 'from #2A1208 l c h',
    '--primary': '#EF8C23',
    '--primary-foreground': '#1A0A04',
    '--primary-foreground-hsl': '16 73% 6%',
    '--primary-foreground-oklch': 'from #1A0A04 l c h',
    '--primary-hsl': '31 86% 54%',
    '--primary-oklch': 'from #EF8C23 l c h',
    '--radius': '12px',
    '--ring': '#EF8C23',
    '--ring-hsl': '31 86% 54%',
    '--ring-oklch': 'from #EF8C23 l c h',
    '--secondary': '#C05A20',
    '--secondary-foreground': '#FFF7ED',
    '--secondary-foreground-hsl': '33 100% 96%',
    '--secondary-foreground-oklch': 'from #FFF7ED l c h',
    '--secondary-hsl': '22 71% 44%',
    '--secondary-oklch': 'from #C05A20 l c h',
    '--shadow-card': '0 12px 28px rgba(0, 0, 0, 0.22)',
    '--shadow-card-active': '0 0 24px color-mix(in srgb, var(--primary) 10%, transparent)',
    '--streak': '#EF8C23',
    '--streak-hsl': '31 86% 54%',
    '--streak-oklch': 'from #EF8C23 l c h',
    '--success': '#22C55E',
    '--success-foreground': '#1A0A04',
    '--success-foreground-hsl': '16 73% 6%',
    '--success-foreground-oklch': 'from #1A0A04 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22C55E l c h',
    '--tint-primary-subtle': 'hsla(31 86% 54% / 0.15)',
    '--xp': '#EF8C23',
    '--xp-bg': '#2A1208',
    '--xp-bg-hsl': '18 68% 10%',
    '--xp-bg-oklch': 'from #2A1208 l c h',
    '--xp-hsl': '31 86% 54%',
    '--xp-oklch': 'from #EF8C23 l c h'
  }
}
